const Signup = () => import('@/pages/signup/Signup');
const SignupCreate = () => import('@/pages/signup/SignupCreate');
const SignupVerify = () => import('@/pages/signup/SignupVerify');
const SuccessRedirect = () => import('@/components/successRedirect/SuccessRedirect');

export default { 
  path: '/signup',
  name: 'signup',
  redirect: '/signup/create',
  component: Signup,
  children: [
    {
      path: 'create',
      name: 'signupCreate',
      component: SignupCreate
    },
    {
      path: 'verify',
      name: 'signupVerify',
      component: SignupVerify,
      meta: { visitDirectly: false },
      props: route => ({
        ...route.params
      })
    },
    {
      path: 'success',
      name: 'signupSucc',
      component: SuccessRedirect,
      meta: { visitDirectly: false }
    }
  ]
};